module.exports = __webpack_public_path__ + "img/logo.bd0cf636.png";